import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

interface Props {
  language: "tr" | "en"
  onComplete: () => void
  onLanguageChange: (l: "tr" | "en") => void
}

const screens = [
  {
    tr: "Bu bir yapılacaklar listesi değil.",
    en: "This is not a to-do list.",
  },
  {
    tr: "Bugün tek bir şey seçeceksin.",
    en: "You will choose one thing today.",
  },
  {
    tr: "Diğerleri gürültü. Onlar bekleyecek.",
    en: "Everything else is noise. It will wait.",
  },
]

export const Onboarding = ({ language, onComplete, onLanguageChange }: Props) => {
  const [index, setIndex] = useState(0)
  const isLast = index === screens.length - 1

  const handleNext = () => {
    if (isLast) {
      localStorage.setItem("dz_onboarding_done", "true")
      onComplete()
    } else {
      setIndex(prev => prev + 1)
    }
  }

  const cta = isLast
    ? (language === "tr" ? "Seç ve başla" : "Choose and begin")
    : (language === "tr" ? "Devam" : "Next")

  return (
    <div className="app">
      <div className="header">
        <h1>DECISION ZERO</h1>
        <div className="lang">
          <button onClick={() => onLanguageChange("en")} disabled={language === "en"}>EN</button>
          <button onClick={() => onLanguageChange("tr")} disabled={language === "tr"}>TR</button>
        </div>
      </div>

      <div className="step-container" style={{ flex: "none", textAlign: "center" }}>
        <div className="step-label" style={{ marginBottom: "32px" }}>BLINDSPOT</div>

        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            style={{ marginBottom: "48px" }}
          >
            <div style={{
              fontSize: "22px",
              fontWeight: "500",
              color: "var(--text-primary)",
              lineHeight: "1.5",
            }}>
              {screens[index][language]}
            </div>
          </motion.div>
        </AnimatePresence>

        <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginBottom: "32px" }}>
          {screens.map((_, i) => (
            <div key={i} style={{
              width: i === index ? "20px" : "6px",
              height: "6px",
              borderRadius: "3px",
              background: i === index ? "var(--accent)" : "rgba(255,255,255,0.15)",
              transition: "all 0.3s ease",
            }} />
          ))}
        </div>

        <button onClick={handleNext} className="btn-primary">
          {cta}
        </button>
      </div>
    </div>
  )
}